"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskRedirect = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const Workflow_context_1 = require("../../Workflow.context");
const useTaskEntityManager_1 = require("./useTaskEntityManager");
function useTaskRedirect() {
    const history = (0, react_router_dom_1.useHistory)();
    const { findAsync: findWorkflowAsync } = (0, Workflow_context_1.useWorkflowContext)();
    const { findAsync: findEntityAsync } = (0, useTaskEntityManager_1.useTaskEntityManager)();
    const getRedirectUrl = (0, react_1.useCallback)((task) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const taskValue = (task === null || task === void 0 ? void 0 : task.parent) || task;
        if (!(taskValue === null || taskValue === void 0 ? void 0 : taskValue.id)) {
            return;
        }
        const workflowItem = yield findWorkflowAsync(taskValue);
        const taskPath = (_b = (_a = workflowItem === null || workflowItem === void 0 ? void 0 : workflowItem.workflowVersion) === null || _a === void 0 ? void 0 : _a.workflow) === null || _b === void 0 ? void 0 : _b.taskPath;
        if (!taskPath) {
            return;
        }
        const taskEntity = yield findEntityAsync(taskValue.id);
        if (!taskEntity) {
            return;
        }
        // assume taskEntity has id property
        let path = taskPath.replace(':id', taskEntity.id.toString());
        path = !path.startsWith('/') ? `/${path}` : path;
        return path;
    }), [findEntityAsync, findWorkflowAsync]);
    const redirect = (0, react_1.useCallback)((task) => __awaiter(this, void 0, void 0, function* () {
        const path = yield getRedirectUrl(task);
        path && history.push(path);
        return !!path;
    }), [history, getRedirectUrl]);
    return { getRedirectUrl, redirect };
}
exports.useTaskRedirect = useTaskRedirect;
//# sourceMappingURL=useTaskRedirect.js.map